import { render, staticRenderFns } from "./CoozzyVerticalRuler.vue?vue&type=template&id=8b7a960a&scoped=true"
import script from "./CoozzyVerticalRuler.vue?vue&type=script&lang=js"
export * from "./CoozzyVerticalRuler.vue?vue&type=script&lang=js"
import style0 from "./CoozzyVerticalRuler.vue?vue&type=style&index=0&id=8b7a960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7a960a",
  null
  
)

export default component.exports